import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { Box, Container, MenuItem } from '@mui/material';
import FormSelectField from '../../common/components/FormSelectField';
import { AGE_RANGES } from './ageRanges';
import SecondaryButton from "../../common/components/SecondaryButton";
import StartCoachTrialDialog from './StartCoachTrialDialog';
import AthleteWelcomeDialog from './AthleteWelcomeDialog';

const COACH_TRIAL_PARAM = 'coachTrial';
const ATHLETE_WELCOME_PARAM = 'newAccount';

export default function Account() {
    const { search } = useLocation();
    const [ageRange, setAgeRange] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [isTrialDialogOpen, setIsTrialDialogOpen] = useState(
        () => new URLSearchParams(search).get(COACH_TRIAL_PARAM) === 'true'
    );

    const [isWelcomeDialogOpen, setIsWelcomeDialogOpen] = useState(
        () => new URLSearchParams(search).get(ATHLETE_WELCOME_PARAM) === 'true'
    );

    const startTrial = () => {
        setIsTrialDialogOpen(false);

    }

    return (
        <Box className="outer-container with-nav">
            <Container maxWidth="lg">
                <Box className="management-header">
                    <header>
                        <h1 className="title">Account</h1>
                    </header>
                </Box>
                <FormSelectField
                    required={false}
                    label="Age Range"
                    value={ageRange}
                    onChange={event => setAgeRange(event.target.value)}
                    open={isOpen}
                    onOpen={() => setIsOpen(true)}
                    onClose={() => setIsOpen(false)}
                    renderValue={(value: string) => value}
                >
                    {AGE_RANGES.map(range => (
                        <MenuItem key={range} value={range}>
                            {range}
                        </MenuItem>
                    ))}
                </FormSelectField>
                <ul>
                    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
                    <li>Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>
                    <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.</li>
                </ul>
                <SecondaryButton onClick={() => setIsTrialDialogOpen(true)}>Start Coach Trial</SecondaryButton>
                <StartCoachTrialDialog
                    isOpen={isTrialDialogOpen}
                    handleClose={() => setIsTrialDialogOpen(false)}
                    startTrial={startTrial}
                />
                <AthleteWelcomeDialog isOpen={isWelcomeDialogOpen} handleClose={() => setIsWelcomeDialogOpen(false)} />
            </Container>
        </Box>
    );
}
